module.exports = __webpack_public_path__ + "img/SN.42cfbd39.svg";